import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';
import { IrisFolderSvgComponent } from '../icons/folder-svg/folder-svg.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'iris-empty-content-view',
  templateUrl: './empty-content-view.component.html',
  styleUrls: ['./empty-content-view.component.scss'],
  imports: [
    NgClass,
    TranslateModule,
    IrisFolderSvgComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisEmptyContentViewComponent implements ILoadingOverlayAngularComp {
  @Input() label = '';
  @Input() message = '';
  @Input() iconClass = '';
  @Input() hasChildren = false;

  agInit(params: ILoadingOverlayParams & Record<string, string>): void {
    this.label = params.emptyContentLabel;
    this.message = params.emptyContentMessage;
    this.iconClass = params.emptyContentIconClass;
  }
}
